import { string } from 'yup';

const obj =  {
	field:[
		
        { 
			title: "Reword outreach emails", 
			attr: "content",  
			value: "", 
			id:"mail",
			placeholder: "Specify the mail to rephrase it", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Re word out reach emails is Required "),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
	
    example:[
	
        { 
			title: "Reword outreach emails", 
			attr: "content",  
			value: "Aaron", 
			id:"mail",
			placeholder: "Specify the mail to rephrase it", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Reword outreach emails is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:`Dear Aaron,\nI am excited to apply for the Mail Delivery position at [Company Name]! With my [X] years of experience in a similar role and valid [state-specific driver's license], I believe I can be a great addition to your team.\nI would love the opportunity to discuss my qualifications further with you. Thank you for considering my application.\nSincerely, `,
        
        
         
        
	}
}
    
export default obj